import { QESSelect } from "@app/shared/qes-standards/forms/Select"
import { FC, useContext, useMemo, useState } from "react"
import { ReportCustomizationContext } from "../ReportCustomizationContext"
import { FlyoutLink } from "@app/shared/Flyouts";
import { ColumnConfigurationPanel, PanelMode } from "./ColumnConfigurationPanel";
import { ExportModels } from "../interfaces/exportModels";
import { ReportCustomizationReducerActions } from "../interfaces/reportCustomizationReducerActionsEnum";
import { ExportColumn } from "../interfaces/exportColumns";

interface ColumnConfigurationSectionProps {
  columnsEndpoint: (model: ExportModels) => Promise<ExportColumn[]>;
  exportModel: ExportModels;
}

export const ColumnConfigurationSection: FC<ColumnConfigurationSectionProps> = (props: ColumnConfigurationSectionProps) => {
  const rcContext = useContext(ReportCustomizationContext);
  const [hasConfigurationChanges, setHasConfigurationChanges] = useState(false);

  const presetsOptions = useMemo(() => {
    return rcContext.state.presets.map((p) => <option key={p.id} value={p.id}>{p.name}</option>);
  }, [rcContext.state.presets]);

  const allPresetNames = useMemo(() => {
    return rcContext.state.presets.filter((p) => p.isPrivate).map((p) => p.name);
  }, [rcContext.state.presets]);

  return (
    <>
      <div className="row mt-3">
        <h2 className="header-s col-auto">Column Configuration</h2>
      </div>
      <div className="row">
        <QESSelect
          label="Preset"
          containerClassName="col-4"
          value={rcContext.state.selectedPreset?.id}
          onChange={(e) => rcContext.dispatch({ payload: { selectedPreset: rcContext.state.presets.find((p) => p?.id.toString() === e.target.value) }, type: ReportCustomizationReducerActions.ChangeSelectedPreset })}
          testId="report-customization__preset"
        >
          {presetsOptions}
        </QESSelect>
        <div className="align-self-end">
          {rcContext.state.selectedPreset.id !== -1 && (
            <FlyoutLink
              classNames="qes-button-secondary"
              testId="report-customization__create-new-preset"
              content={{
                body: (
                  <ColumnConfigurationPanel
                    setHasConfigurationChanges={setHasConfigurationChanges}
                    columnsEndpoint={props.columnsEndpoint}
                    exportModel={props.exportModel}
                    panelMode={PanelMode.View}
                    allPrivatePresetNames={allPresetNames}
                    reportType={rcContext.state.reportType}
                    presetId={rcContext.state.selectedPreset.id}
                  />
                ),
                title: "Column Configuration",
              }}
              size="40"
            >
              Preview
            </FlyoutLink>
          )}
          or
          <FlyoutLink
            classNames="qes-button-secondary"
            testId="report-customization__create-new-preset"
            content={{
              body: (
                <ColumnConfigurationPanel
                  setHasConfigurationChanges={setHasConfigurationChanges}
                  columnsEndpoint={props.columnsEndpoint}
                  exportModel={props.exportModel}
                  panelMode={PanelMode.Create}
                  allPrivatePresetNames={allPresetNames}
                  reportType={rcContext.state.reportType}
                  onSuccessfulSubmit={rcContext.changeLoadedPresets}
                />
              ),
              title: "Column Configuration",
            }}
            modalContent={{
              body: "You will lose unsaved changes. Continue with closing the sidebar?",
              cancelButtonText: "Cancel",
              confirmButtonText: "Continue",
              title: "Warning",
            }}
            warnOnClose={hasConfigurationChanges}
            size="40"
          >
            Create New
          </FlyoutLink>
        </div>
      </div>
    </>
  )
}